'use client'

import { type FC, useEffect } from 'react'

import { apmCaptureError, apmSetCustomContext } from '../../apm'
import { ErrorPageError } from '../ErrorPageError'

import '../../../styles/globals.css'

const GLOBAL_ERROR_PAGE_TITLE = 'Internal Server Error'

type GlobalErrorPageProps = {
  error: Error & { digest?: string }
}

export const GlobalErrorPage: FC<GlobalErrorPageProps> = ({ error }) => {
  useEffect(() => {
    apmSetCustomContext({
      digest: error.digest,
      router: 'app',
    })
    apmCaptureError(new ErrorPageError(error.message, { cause: error }))
  }, [error])

  return (
    <html lang="en">
      <head>
        <title>{GLOBAL_ERROR_PAGE_TITLE}</title>
        <meta content="width=device-width, initial-scale=1" name="viewport" />
      </head>
      <body data-qa-id="home-one-app">
        <main className="container py-4">
          <h1 className="text-center text-4xl">{GLOBAL_ERROR_PAGE_TITLE}</h1>
        </main>
      </body>
    </html>
  )
}
